import { render, staticRenderFns } from "./Successors.vue?vue&type=template&id=0e017986"
import script from "./Successors.vue?vue&type=script&lang=js"
export * from "./Successors.vue?vue&type=script&lang=js"
import style0 from "./Successors.vue?vue&type=style&index=0&id=0e017986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports